import store from "../store/store";
import router from "./router";

export default (to, from, next) => {
  console.log(to);
  console.log(from);
  console.log(next);

  const graphqlError = JSON.parse(localStorage.getItem("graphqlError")) || "";

  if (!graphqlError) {
    next(); // Proceed if no error is present
    return;
  }

  const { message, path } = graphqlError;

  // Check if user is available, if not, wait for it to load
  const checkUser = () => {
    if (store.getters.user) {
      // Proceed if user is found
      handleGraphQLError(message, path, next, to);
    } else {
      // If user is not found, retry after a delay (e.g., 100ms)
      setTimeout(checkUser, 100);
    }
  };

  const handleGraphQLError = (message, path, next, to) => {
    if (message === "Signature has expired" && path.includes("getCurrentUser")) {
      store.dispatch("getNewToken").then(() => {
        console.log("Token refreshed, continuing...");
        next(); // Proceed after refreshing the token
      }).catch((error) => {
        console.error("Error refreshing token", error);
        router.push("/auth/signin"); // Redirect if token refresh fails
      });
    } else if (
      (message === "Signature has expired" && path.includes("getNewAccessToken")) ||
      message === "Only access tokens are allowed"
    ) {
      console.log("Redirecting to sign-in page...");
      router.push({ path: "/auth/signin", query: { redirect: to.fullPath } });
    } else {
      // Proceed if no error or valid conditions
      next();
    }
  };

  // Start the user check
  checkUser();
};
